unit View.Plano_Contas.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewPlano_ContasEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbplano_contas1_id: TLabel;
    edplano_contas1_id: TDBEdit;
    lbplano_contas2_id: TLabel;
    edplano_contas2_id: TDBEdit;
    lbplano_contas3_id: TLabel;
    edplano_contas3_id: TDBEdit;
    lbplano_contas_contabil_id: TLabel;
    edplano_contas_contabil_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbclasse: TLabel;
    edclasse: TDBEdit;
    lbpeso_ideal: TLabel;
    edpeso_ideal: TDBEdit;
    lbaparece_dre: TLabel;
    edaparece_dre: TDBEdit;
    lbdebito_credito: TLabel;
    eddebito_credito: TDBEdit;
    lbdeducao_adicao: TLabel;
    eddeducao_adicao: TDBEdit;
    lbdespesas: TLabel;
    eddespesas: TDBEdit;
    lbinvestimentos: TLabel;
    edinvestimentos: TDBEdit;
    lbbalanco_patrimonial: TLabel;
    edbalanco_patrimonial: TDBEdit;
    lbdemonstrativo_financeiro: TLabel;
    eddemonstrativo_financeiro: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientPlano_ContasGet: TXDataWebClient;
    XDataClientPlano_ContasDelete: TXDataWebClient;
    Plano_ContasDataset: TXDataWebDataSet;
    Plano_ContasDatasetid: TIntegerField;
    Plano_ContasDatasetaliado_id: TIntegerField;
    Plano_ContasDatasetdata_base_id: TIntegerField;
    Plano_ContasDatasetplano_contas1_id: TIntegerField;
    Plano_ContasDatasetplano_contas2_id: TIntegerField;
    Plano_ContasDatasetplano_contas3_id: TIntegerField;
    Plano_ContasDatasetplano_contas_contabil_id: TIntegerField;
    Plano_ContasDatasetnome: TStringField;
    Plano_ContasDatasetclasse: TIntegerField;
    Plano_ContasDatasetpeso_ideal: TFloatField;
    Plano_ContasDatasetaparece_dre: TBooleanField;
    Plano_ContasDatasetdebito_credito: TIntegerField;
    Plano_ContasDatasetdeducao_adicao: TIntegerField;
    Plano_ContasDatasetdespesas: TBooleanField;
    Plano_ContasDatasetinvestimentos: TBooleanField;
    Plano_ContasDatasetbalanco_patrimonial: TBooleanField;
    Plano_ContasDatasetdemonstrativo_financeiro: TBooleanField;
    Plano_ContasDatasetcodigo_interno: TIntegerField;
    Plano_ContasDatasetexcluido: TBooleanField;
    Plano_ContasDatasetinclusao: TDateTimeField;
    Plano_ContasDatasetalteracao: TDateTimeField;
    Plano_ContasDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientPlano_ContasGetLoad(Response: TXDataClientResponse);
    procedure XDataClientPlano_ContasDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientPlano_ContasDeleteError(Error: TXDataClientError);
    procedure Plano_ContasDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewPlano_ContasEdit: TFViewPlano_ContasEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewPlano_ContasEdit }

procedure TFViewPlano_ContasEdit.btSaveClick(Sender: TObject);
begin
  if Plano_ContasDataset.State in dsEditModes then
  begin
        Plano_ContasDataset.Post;
    Plano_ContasDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewPlano_ContasEdit.btDeleteClick(Sender: TObject);
begin
  if Plano_ContasDataset.State in dsEditModes then
    Plano_ContasDataset.Post;
  XDataClientPlano_ContasDelete.Delete(Plano_ContasDataset.EntitySetName,
    TJSObject(Plano_ContasDataset.CurrentData));
end;


class function TFViewPlano_ContasEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewPlano_ContasEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewPlano_ContasEdit.InsertEntity;
begin
  Plano_ContasDataset.Close;
  Plano_ContasDataset.SetJsonData('{}');
  Plano_ContasDataset.Open;
  Plano_ContasDataset.Insert;
end;

class function TFViewPlano_ContasEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewPlano_ContasEdit(AForm).FInserting := AInserting;
    TFViewPlano_ContasEdit(AForm).FId := AId;
    TFViewPlano_ContasEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewPlano_ContasEdit(AForm).InsertEntity
    else
      TFViewPlano_ContasEdit(AForm).LoadEntity;
    TFViewPlano_ContasEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewPlano_ContasEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewPlano_ContasEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Plano_ContasDataset.Connection.Model.DefaultSchema.FindEntityType(
      Plano_ContasDataset.EntitySetName
    )
  );
  XDataClientPlano_ContasGet.Get(Plano_ContasDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewPlano_ContasEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewPlano_ContasEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewPlano_ContasEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewPlano_ContasEdit.XDataClientPlano_ContasGetLoad(Response: TXDataClientResponse);
begin
  Plano_ContasDataset.Close;
  Plano_ContasDataset.SetJsonData(Response.Result);
  Plano_ContasDataset.Open;
  
  Plano_ContasDataset.Edit;  
end;

procedure TFViewPlano_ContasEdit.XDataClientPlano_ContasDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewPlano_ContasEdit.XDataClientPlano_ContasDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewPlano_ContasEdit.Plano_ContasDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewPlano_ContasEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewPlano_ContasEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.plano_contas.form.message');
  lbMessage := TLabel.Create('view.plano_contas.form.message.label');
  btCloseMessage := TButton.Create('view.plano_contas.form.message.button');
  btCancel := TButton.Create('view.plano_contas.form.btBack');
  btSave := TButton.Create('view.plano_contas.form.btSave');
  btDelete := TButton.Create('view.plano_contas.form.btDelete');
  lbid := TLabel.Create('view.plano_contas.form.lbid');
  edid := TDBEdit.Create('view.plano_contas.form.edid');
  lbaliado_id := TLabel.Create('view.plano_contas.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.plano_contas.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.plano_contas.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.plano_contas.form.eddata_base_id');
  lbplano_contas1_id := TLabel.Create('view.plano_contas.form.lbplano_contas1_id');
  edplano_contas1_id := TDBEdit.Create('view.plano_contas.form.edplano_contas1_id');
  lbplano_contas2_id := TLabel.Create('view.plano_contas.form.lbplano_contas2_id');
  edplano_contas2_id := TDBEdit.Create('view.plano_contas.form.edplano_contas2_id');
  lbplano_contas3_id := TLabel.Create('view.plano_contas.form.lbplano_contas3_id');
  edplano_contas3_id := TDBEdit.Create('view.plano_contas.form.edplano_contas3_id');
  lbplano_contas_contabil_id := TLabel.Create('view.plano_contas.form.lbplano_contas_contabil_id');
  edplano_contas_contabil_id := TDBEdit.Create('view.plano_contas.form.edplano_contas_contabil_id');
  lbnome := TLabel.Create('view.plano_contas.form.lbnome');
  ednome := TDBEdit.Create('view.plano_contas.form.ednome');
  lbclasse := TLabel.Create('view.plano_contas.form.lbclasse');
  edclasse := TDBEdit.Create('view.plano_contas.form.edclasse');
  lbpeso_ideal := TLabel.Create('view.plano_contas.form.lbpeso_ideal');
  edpeso_ideal := TDBEdit.Create('view.plano_contas.form.edpeso_ideal');
  lbaparece_dre := TLabel.Create('view.plano_contas.form.lbaparece_dre');
  edaparece_dre := TDBEdit.Create('view.plano_contas.form.edaparece_dre');
  lbdebito_credito := TLabel.Create('view.plano_contas.form.lbdebito_credito');
  eddebito_credito := TDBEdit.Create('view.plano_contas.form.eddebito_credito');
  lbdeducao_adicao := TLabel.Create('view.plano_contas.form.lbdeducao_adicao');
  eddeducao_adicao := TDBEdit.Create('view.plano_contas.form.eddeducao_adicao');
  lbdespesas := TLabel.Create('view.plano_contas.form.lbdespesas');
  eddespesas := TDBEdit.Create('view.plano_contas.form.eddespesas');
  lbinvestimentos := TLabel.Create('view.plano_contas.form.lbinvestimentos');
  edinvestimentos := TDBEdit.Create('view.plano_contas.form.edinvestimentos');
  lbbalanco_patrimonial := TLabel.Create('view.plano_contas.form.lbbalanco_patrimonial');
  edbalanco_patrimonial := TDBEdit.Create('view.plano_contas.form.edbalanco_patrimonial');
  lbdemonstrativo_financeiro := TLabel.Create('view.plano_contas.form.lbdemonstrativo_financeiro');
  eddemonstrativo_financeiro := TDBEdit.Create('view.plano_contas.form.eddemonstrativo_financeiro');
  lbcodigo_interno := TLabel.Create('view.plano_contas.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.plano_contas.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.plano_contas.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.plano_contas.form.edexcluido');
  lbinclusao := TLabel.Create('view.plano_contas.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.plano_contas.form.edinclusao');
  lbalteracao := TLabel.Create('view.plano_contas.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.plano_contas.form.edalteracao');
  lbexclusao := TLabel.Create('view.plano_contas.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.plano_contas.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Plano_ContasDataset := TXDataWebDataSet.Create(Self);
  Plano_ContasDatasetid := TIntegerField.Create(Self);
  Plano_ContasDatasetaliado_id := TIntegerField.Create(Self);
  Plano_ContasDatasetdata_base_id := TIntegerField.Create(Self);
  Plano_ContasDatasetplano_contas1_id := TIntegerField.Create(Self);
  Plano_ContasDatasetplano_contas2_id := TIntegerField.Create(Self);
  Plano_ContasDatasetplano_contas3_id := TIntegerField.Create(Self);
  Plano_ContasDatasetplano_contas_contabil_id := TIntegerField.Create(Self);
  Plano_ContasDatasetnome := TStringField.Create(Self);
  Plano_ContasDatasetclasse := TIntegerField.Create(Self);
  Plano_ContasDatasetpeso_ideal := TFloatField.Create(Self);
  Plano_ContasDatasetaparece_dre := TBooleanField.Create(Self);
  Plano_ContasDatasetdebito_credito := TIntegerField.Create(Self);
  Plano_ContasDatasetdeducao_adicao := TIntegerField.Create(Self);
  Plano_ContasDatasetdespesas := TBooleanField.Create(Self);
  Plano_ContasDatasetinvestimentos := TBooleanField.Create(Self);
  Plano_ContasDatasetbalanco_patrimonial := TBooleanField.Create(Self);
  Plano_ContasDatasetdemonstrativo_financeiro := TBooleanField.Create(Self);
  Plano_ContasDatasetcodigo_interno := TIntegerField.Create(Self);
  Plano_ContasDatasetexcluido := TBooleanField.Create(Self);
  Plano_ContasDatasetinclusao := TDateTimeField.Create(Self);
  Plano_ContasDatasetalteracao := TDateTimeField.Create(Self);
  Plano_ContasDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientPlano_ContasGet := TXDataWebClient.Create(Self);
  XDataClientPlano_ContasDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbplano_contas1_id.BeforeLoadDFMValues;
  edplano_contas1_id.BeforeLoadDFMValues;
  lbplano_contas2_id.BeforeLoadDFMValues;
  edplano_contas2_id.BeforeLoadDFMValues;
  lbplano_contas3_id.BeforeLoadDFMValues;
  edplano_contas3_id.BeforeLoadDFMValues;
  lbplano_contas_contabil_id.BeforeLoadDFMValues;
  edplano_contas_contabil_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbclasse.BeforeLoadDFMValues;
  edclasse.BeforeLoadDFMValues;
  lbpeso_ideal.BeforeLoadDFMValues;
  edpeso_ideal.BeforeLoadDFMValues;
  lbaparece_dre.BeforeLoadDFMValues;
  edaparece_dre.BeforeLoadDFMValues;
  lbdebito_credito.BeforeLoadDFMValues;
  eddebito_credito.BeforeLoadDFMValues;
  lbdeducao_adicao.BeforeLoadDFMValues;
  eddeducao_adicao.BeforeLoadDFMValues;
  lbdespesas.BeforeLoadDFMValues;
  eddespesas.BeforeLoadDFMValues;
  lbinvestimentos.BeforeLoadDFMValues;
  edinvestimentos.BeforeLoadDFMValues;
  lbbalanco_patrimonial.BeforeLoadDFMValues;
  edbalanco_patrimonial.BeforeLoadDFMValues;
  lbdemonstrativo_financeiro.BeforeLoadDFMValues;
  eddemonstrativo_financeiro.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Plano_ContasDataset.BeforeLoadDFMValues;
  Plano_ContasDatasetid.BeforeLoadDFMValues;
  Plano_ContasDatasetaliado_id.BeforeLoadDFMValues;
  Plano_ContasDatasetdata_base_id.BeforeLoadDFMValues;
  Plano_ContasDatasetplano_contas1_id.BeforeLoadDFMValues;
  Plano_ContasDatasetplano_contas2_id.BeforeLoadDFMValues;
  Plano_ContasDatasetplano_contas3_id.BeforeLoadDFMValues;
  Plano_ContasDatasetplano_contas_contabil_id.BeforeLoadDFMValues;
  Plano_ContasDatasetnome.BeforeLoadDFMValues;
  Plano_ContasDatasetclasse.BeforeLoadDFMValues;
  Plano_ContasDatasetpeso_ideal.BeforeLoadDFMValues;
  Plano_ContasDatasetaparece_dre.BeforeLoadDFMValues;
  Plano_ContasDatasetdebito_credito.BeforeLoadDFMValues;
  Plano_ContasDatasetdeducao_adicao.BeforeLoadDFMValues;
  Plano_ContasDatasetdespesas.BeforeLoadDFMValues;
  Plano_ContasDatasetinvestimentos.BeforeLoadDFMValues;
  Plano_ContasDatasetbalanco_patrimonial.BeforeLoadDFMValues;
  Plano_ContasDatasetdemonstrativo_financeiro.BeforeLoadDFMValues;
  Plano_ContasDatasetcodigo_interno.BeforeLoadDFMValues;
  Plano_ContasDatasetexcluido.BeforeLoadDFMValues;
  Plano_ContasDatasetinclusao.BeforeLoadDFMValues;
  Plano_ContasDatasetalteracao.BeforeLoadDFMValues;
  Plano_ContasDatasetexclusao.BeforeLoadDFMValues;
  XDataClientPlano_ContasGet.BeforeLoadDFMValues;
  XDataClientPlano_ContasDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewPlano_ContasEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 859;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 799;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 799;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 799;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbplano_contas1_id.SetParentComponent(Self);
    lbplano_contas1_id.Name := 'lbplano_contas1_id';
    lbplano_contas1_id.Left := 24;
    lbplano_contas1_id.Top := 273;
    lbplano_contas1_id.Width := 14;
    lbplano_contas1_id.Height := 13;
    lbplano_contas1_id.Caption := 'plano_contas1_id:';
    lbplano_contas1_id.Transparent := True;
    edplano_contas1_id.SetParentComponent(Self);
    edplano_contas1_id.Name := 'edplano_contas1_id';
    edplano_contas1_id.Left := 221;
    edplano_contas1_id.Top := 270;
    edplano_contas1_id.Width := 200;
    edplano_contas1_id.Height := 21;
    edplano_contas1_id.Enabled := True;
    edplano_contas1_id.TabOrder := 9;
    edplano_contas1_id.Text := 'edplano_contas1_id';
    edplano_contas1_id.DataField := 'plano_contas1_id';
    edplano_contas1_id.DataSource := DataSource;
    lbplano_contas2_id.SetParentComponent(Self);
    lbplano_contas2_id.Name := 'lbplano_contas2_id';
    lbplano_contas2_id.Left := 24;
    lbplano_contas2_id.Top := 300;
    lbplano_contas2_id.Width := 14;
    lbplano_contas2_id.Height := 13;
    lbplano_contas2_id.Caption := 'plano_contas2_id:';
    lbplano_contas2_id.Transparent := True;
    edplano_contas2_id.SetParentComponent(Self);
    edplano_contas2_id.Name := 'edplano_contas2_id';
    edplano_contas2_id.Left := 221;
    edplano_contas2_id.Top := 297;
    edplano_contas2_id.Width := 200;
    edplano_contas2_id.Height := 21;
    edplano_contas2_id.Enabled := True;
    edplano_contas2_id.TabOrder := 10;
    edplano_contas2_id.Text := 'edplano_contas2_id';
    edplano_contas2_id.DataField := 'plano_contas2_id';
    edplano_contas2_id.DataSource := DataSource;
    lbplano_contas3_id.SetParentComponent(Self);
    lbplano_contas3_id.Name := 'lbplano_contas3_id';
    lbplano_contas3_id.Left := 24;
    lbplano_contas3_id.Top := 327;
    lbplano_contas3_id.Width := 14;
    lbplano_contas3_id.Height := 13;
    lbplano_contas3_id.Caption := 'plano_contas3_id:';
    lbplano_contas3_id.Transparent := True;
    edplano_contas3_id.SetParentComponent(Self);
    edplano_contas3_id.Name := 'edplano_contas3_id';
    edplano_contas3_id.Left := 221;
    edplano_contas3_id.Top := 324;
    edplano_contas3_id.Width := 200;
    edplano_contas3_id.Height := 21;
    edplano_contas3_id.Enabled := True;
    edplano_contas3_id.TabOrder := 11;
    edplano_contas3_id.Text := 'edplano_contas3_id';
    edplano_contas3_id.DataField := 'plano_contas3_id';
    edplano_contas3_id.DataSource := DataSource;
    lbplano_contas_contabil_id.SetParentComponent(Self);
    lbplano_contas_contabil_id.Name := 'lbplano_contas_contabil_id';
    lbplano_contas_contabil_id.Left := 24;
    lbplano_contas_contabil_id.Top := 354;
    lbplano_contas_contabil_id.Width := 14;
    lbplano_contas_contabil_id.Height := 13;
    lbplano_contas_contabil_id.Caption := 'plano_contas_contabil_id:';
    lbplano_contas_contabil_id.Transparent := True;
    edplano_contas_contabil_id.SetParentComponent(Self);
    edplano_contas_contabil_id.Name := 'edplano_contas_contabil_id';
    edplano_contas_contabil_id.Left := 221;
    edplano_contas_contabil_id.Top := 351;
    edplano_contas_contabil_id.Width := 200;
    edplano_contas_contabil_id.Height := 21;
    edplano_contas_contabil_id.Enabled := True;
    edplano_contas_contabil_id.TabOrder := 12;
    edplano_contas_contabil_id.Text := 'edplano_contas_contabil_id';
    edplano_contas_contabil_id.DataField := 'plano_contas_contabil_id';
    edplano_contas_contabil_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 381;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 378;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 13;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbclasse.SetParentComponent(Self);
    lbclasse.Name := 'lbclasse';
    lbclasse.Left := 24;
    lbclasse.Top := 408;
    lbclasse.Width := 14;
    lbclasse.Height := 13;
    lbclasse.Caption := 'classe:';
    lbclasse.Transparent := True;
    edclasse.SetParentComponent(Self);
    edclasse.Name := 'edclasse';
    edclasse.Left := 221;
    edclasse.Top := 405;
    edclasse.Width := 200;
    edclasse.Height := 21;
    edclasse.Enabled := True;
    edclasse.TabOrder := 14;
    edclasse.Text := 'edclasse';
    edclasse.DataField := 'classe';
    edclasse.DataSource := DataSource;
    lbpeso_ideal.SetParentComponent(Self);
    lbpeso_ideal.Name := 'lbpeso_ideal';
    lbpeso_ideal.Left := 24;
    lbpeso_ideal.Top := 435;
    lbpeso_ideal.Width := 14;
    lbpeso_ideal.Height := 13;
    lbpeso_ideal.Caption := 'peso_ideal:';
    lbpeso_ideal.Transparent := True;
    edpeso_ideal.SetParentComponent(Self);
    edpeso_ideal.Name := 'edpeso_ideal';
    edpeso_ideal.Left := 221;
    edpeso_ideal.Top := 432;
    edpeso_ideal.Width := 200;
    edpeso_ideal.Height := 21;
    edpeso_ideal.Enabled := True;
    edpeso_ideal.TabOrder := 15;
    edpeso_ideal.Text := 'edpeso_ideal';
    edpeso_ideal.DataField := 'peso_ideal';
    edpeso_ideal.DataSource := DataSource;
    lbaparece_dre.SetParentComponent(Self);
    lbaparece_dre.Name := 'lbaparece_dre';
    lbaparece_dre.Left := 24;
    lbaparece_dre.Top := 462;
    lbaparece_dre.Width := 14;
    lbaparece_dre.Height := 13;
    lbaparece_dre.Caption := 'aparece_dre:';
    lbaparece_dre.Transparent := True;
    edaparece_dre.SetParentComponent(Self);
    edaparece_dre.Name := 'edaparece_dre';
    edaparece_dre.Left := 221;
    edaparece_dre.Top := 459;
    edaparece_dre.Width := 200;
    edaparece_dre.Height := 21;
    edaparece_dre.Enabled := True;
    edaparece_dre.TabOrder := 16;
    edaparece_dre.Text := 'edaparece_dre';
    edaparece_dre.DataField := 'aparece_dre';
    edaparece_dre.DataSource := DataSource;
    lbdebito_credito.SetParentComponent(Self);
    lbdebito_credito.Name := 'lbdebito_credito';
    lbdebito_credito.Left := 24;
    lbdebito_credito.Top := 489;
    lbdebito_credito.Width := 14;
    lbdebito_credito.Height := 13;
    lbdebito_credito.Caption := 'debito_credito:';
    lbdebito_credito.Transparent := True;
    eddebito_credito.SetParentComponent(Self);
    eddebito_credito.Name := 'eddebito_credito';
    eddebito_credito.Left := 221;
    eddebito_credito.Top := 486;
    eddebito_credito.Width := 200;
    eddebito_credito.Height := 21;
    eddebito_credito.Enabled := True;
    eddebito_credito.TabOrder := 17;
    eddebito_credito.Text := 'eddebito_credito';
    eddebito_credito.DataField := 'debito_credito';
    eddebito_credito.DataSource := DataSource;
    lbdeducao_adicao.SetParentComponent(Self);
    lbdeducao_adicao.Name := 'lbdeducao_adicao';
    lbdeducao_adicao.Left := 24;
    lbdeducao_adicao.Top := 516;
    lbdeducao_adicao.Width := 14;
    lbdeducao_adicao.Height := 13;
    lbdeducao_adicao.Caption := 'deducao_adicao:';
    lbdeducao_adicao.Transparent := True;
    eddeducao_adicao.SetParentComponent(Self);
    eddeducao_adicao.Name := 'eddeducao_adicao';
    eddeducao_adicao.Left := 221;
    eddeducao_adicao.Top := 513;
    eddeducao_adicao.Width := 200;
    eddeducao_adicao.Height := 21;
    eddeducao_adicao.Enabled := True;
    eddeducao_adicao.TabOrder := 18;
    eddeducao_adicao.Text := 'eddeducao_adicao';
    eddeducao_adicao.DataField := 'deducao_adicao';
    eddeducao_adicao.DataSource := DataSource;
    lbdespesas.SetParentComponent(Self);
    lbdespesas.Name := 'lbdespesas';
    lbdespesas.Left := 24;
    lbdespesas.Top := 543;
    lbdespesas.Width := 14;
    lbdespesas.Height := 13;
    lbdespesas.Caption := 'despesas:';
    lbdespesas.Transparent := True;
    eddespesas.SetParentComponent(Self);
    eddespesas.Name := 'eddespesas';
    eddespesas.Left := 221;
    eddespesas.Top := 540;
    eddespesas.Width := 200;
    eddespesas.Height := 21;
    eddespesas.Enabled := True;
    eddespesas.TabOrder := 19;
    eddespesas.Text := 'eddespesas';
    eddespesas.DataField := 'despesas';
    eddespesas.DataSource := DataSource;
    lbinvestimentos.SetParentComponent(Self);
    lbinvestimentos.Name := 'lbinvestimentos';
    lbinvestimentos.Left := 24;
    lbinvestimentos.Top := 570;
    lbinvestimentos.Width := 14;
    lbinvestimentos.Height := 13;
    lbinvestimentos.Caption := 'investimentos:';
    lbinvestimentos.Transparent := True;
    edinvestimentos.SetParentComponent(Self);
    edinvestimentos.Name := 'edinvestimentos';
    edinvestimentos.Left := 221;
    edinvestimentos.Top := 567;
    edinvestimentos.Width := 200;
    edinvestimentos.Height := 21;
    edinvestimentos.Enabled := True;
    edinvestimentos.TabOrder := 20;
    edinvestimentos.Text := 'edinvestimentos';
    edinvestimentos.DataField := 'investimentos';
    edinvestimentos.DataSource := DataSource;
    lbbalanco_patrimonial.SetParentComponent(Self);
    lbbalanco_patrimonial.Name := 'lbbalanco_patrimonial';
    lbbalanco_patrimonial.Left := 24;
    lbbalanco_patrimonial.Top := 597;
    lbbalanco_patrimonial.Width := 14;
    lbbalanco_patrimonial.Height := 13;
    lbbalanco_patrimonial.Caption := 'balanco_patrimonial:';
    lbbalanco_patrimonial.Transparent := True;
    edbalanco_patrimonial.SetParentComponent(Self);
    edbalanco_patrimonial.Name := 'edbalanco_patrimonial';
    edbalanco_patrimonial.Left := 221;
    edbalanco_patrimonial.Top := 594;
    edbalanco_patrimonial.Width := 200;
    edbalanco_patrimonial.Height := 21;
    edbalanco_patrimonial.Enabled := True;
    edbalanco_patrimonial.TabOrder := 21;
    edbalanco_patrimonial.Text := 'edbalanco_patrimonial';
    edbalanco_patrimonial.DataField := 'balanco_patrimonial';
    edbalanco_patrimonial.DataSource := DataSource;
    lbdemonstrativo_financeiro.SetParentComponent(Self);
    lbdemonstrativo_financeiro.Name := 'lbdemonstrativo_financeiro';
    lbdemonstrativo_financeiro.Left := 24;
    lbdemonstrativo_financeiro.Top := 624;
    lbdemonstrativo_financeiro.Width := 14;
    lbdemonstrativo_financeiro.Height := 13;
    lbdemonstrativo_financeiro.Caption := 'demonstrativo_financeiro:';
    lbdemonstrativo_financeiro.Transparent := True;
    eddemonstrativo_financeiro.SetParentComponent(Self);
    eddemonstrativo_financeiro.Name := 'eddemonstrativo_financeiro';
    eddemonstrativo_financeiro.Left := 221;
    eddemonstrativo_financeiro.Top := 621;
    eddemonstrativo_financeiro.Width := 200;
    eddemonstrativo_financeiro.Height := 21;
    eddemonstrativo_financeiro.Enabled := True;
    eddemonstrativo_financeiro.TabOrder := 22;
    eddemonstrativo_financeiro.Text := 'eddemonstrativo_financeiro';
    eddemonstrativo_financeiro.DataField := 'demonstrativo_financeiro';
    eddemonstrativo_financeiro.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 651;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 648;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 23;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 678;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 675;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 24;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 705;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 702;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 25;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 732;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 729;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 26;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 759;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 756;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 27;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Plano_ContasDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Plano_ContasDataset.SetParentComponent(Self);
    Plano_ContasDataset.Name := 'Plano_ContasDataset';
    Plano_ContasDataset.AfterApplyUpdates := Plano_ContasDatasetAfterApplyUpdates;
    Plano_ContasDataset.EntitySetName := 'Plano_Contas';
    Plano_ContasDataset.Connection := DMConnection.ApiConnection;
    Plano_ContasDataset.Left := 176;
    Plano_ContasDataset.Top := 8;
    Plano_ContasDatasetid.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetid.Name := 'Plano_ContasDatasetid';
    Plano_ContasDatasetid.FieldName := 'id';
    Plano_ContasDatasetid.Required := True;
    Plano_ContasDatasetaliado_id.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetaliado_id.Name := 'Plano_ContasDatasetaliado_id';
    Plano_ContasDatasetaliado_id.FieldName := 'aliado_id';
    Plano_ContasDatasetaliado_id.Required := True;
    Plano_ContasDatasetdata_base_id.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetdata_base_id.Name := 'Plano_ContasDatasetdata_base_id';
    Plano_ContasDatasetdata_base_id.FieldName := 'data_base_id';
    Plano_ContasDatasetdata_base_id.Required := True;
    Plano_ContasDatasetplano_contas1_id.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetplano_contas1_id.Name := 'Plano_ContasDatasetplano_contas1_id';
    Plano_ContasDatasetplano_contas1_id.FieldName := 'plano_contas1_id';
    Plano_ContasDatasetplano_contas1_id.Required := False;
    Plano_ContasDatasetplano_contas2_id.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetplano_contas2_id.Name := 'Plano_ContasDatasetplano_contas2_id';
    Plano_ContasDatasetplano_contas2_id.FieldName := 'plano_contas2_id';
    Plano_ContasDatasetplano_contas2_id.Required := False;
    Plano_ContasDatasetplano_contas3_id.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetplano_contas3_id.Name := 'Plano_ContasDatasetplano_contas3_id';
    Plano_ContasDatasetplano_contas3_id.FieldName := 'plano_contas3_id';
    Plano_ContasDatasetplano_contas3_id.Required := False;
    Plano_ContasDatasetplano_contas_contabil_id.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetplano_contas_contabil_id.Name := 'Plano_ContasDatasetplano_contas_contabil_id';
    Plano_ContasDatasetplano_contas_contabil_id.FieldName := 'plano_contas_contabil_id';
    Plano_ContasDatasetplano_contas_contabil_id.Required := False;
    Plano_ContasDatasetnome.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetnome.Name := 'Plano_ContasDatasetnome';
    Plano_ContasDatasetnome.FieldName := 'nome';
    Plano_ContasDatasetnome.Required := True;
    Plano_ContasDatasetnome.Size := 255;
    Plano_ContasDatasetclasse.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetclasse.Name := 'Plano_ContasDatasetclasse';
    Plano_ContasDatasetclasse.FieldName := 'classe';
    Plano_ContasDatasetclasse.Required := False;
    Plano_ContasDatasetpeso_ideal.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetpeso_ideal.Name := 'Plano_ContasDatasetpeso_ideal';
    Plano_ContasDatasetpeso_ideal.FieldName := 'peso_ideal';
    Plano_ContasDatasetpeso_ideal.Required := False;
    Plano_ContasDatasetaparece_dre.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetaparece_dre.Name := 'Plano_ContasDatasetaparece_dre';
    Plano_ContasDatasetaparece_dre.FieldName := 'aparece_dre';
    Plano_ContasDatasetaparece_dre.Required := False;
    Plano_ContasDatasetdebito_credito.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetdebito_credito.Name := 'Plano_ContasDatasetdebito_credito';
    Plano_ContasDatasetdebito_credito.FieldName := 'debito_credito';
    Plano_ContasDatasetdebito_credito.Required := False;
    Plano_ContasDatasetdeducao_adicao.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetdeducao_adicao.Name := 'Plano_ContasDatasetdeducao_adicao';
    Plano_ContasDatasetdeducao_adicao.FieldName := 'deducao_adicao';
    Plano_ContasDatasetdeducao_adicao.Required := False;
    Plano_ContasDatasetdespesas.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetdespesas.Name := 'Plano_ContasDatasetdespesas';
    Plano_ContasDatasetdespesas.FieldName := 'despesas';
    Plano_ContasDatasetdespesas.Required := True;
    Plano_ContasDatasetinvestimentos.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetinvestimentos.Name := 'Plano_ContasDatasetinvestimentos';
    Plano_ContasDatasetinvestimentos.FieldName := 'investimentos';
    Plano_ContasDatasetinvestimentos.Required := True;
    Plano_ContasDatasetbalanco_patrimonial.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetbalanco_patrimonial.Name := 'Plano_ContasDatasetbalanco_patrimonial';
    Plano_ContasDatasetbalanco_patrimonial.FieldName := 'balanco_patrimonial';
    Plano_ContasDatasetbalanco_patrimonial.Required := True;
    Plano_ContasDatasetdemonstrativo_financeiro.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetdemonstrativo_financeiro.Name := 'Plano_ContasDatasetdemonstrativo_financeiro';
    Plano_ContasDatasetdemonstrativo_financeiro.FieldName := 'demonstrativo_financeiro';
    Plano_ContasDatasetdemonstrativo_financeiro.Required := True;
    Plano_ContasDatasetcodigo_interno.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetcodigo_interno.Name := 'Plano_ContasDatasetcodigo_interno';
    Plano_ContasDatasetcodigo_interno.FieldName := 'codigo_interno';
    Plano_ContasDatasetcodigo_interno.Required := True;
    Plano_ContasDatasetexcluido.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetexcluido.Name := 'Plano_ContasDatasetexcluido';
    Plano_ContasDatasetexcluido.FieldName := 'excluido';
    Plano_ContasDatasetexcluido.Required := False;
    Plano_ContasDatasetinclusao.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetinclusao.Name := 'Plano_ContasDatasetinclusao';
    Plano_ContasDatasetinclusao.FieldName := 'inclusao';
    Plano_ContasDatasetinclusao.Required := False;
    Plano_ContasDatasetalteracao.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetalteracao.Name := 'Plano_ContasDatasetalteracao';
    Plano_ContasDatasetalteracao.FieldName := 'alteracao';
    Plano_ContasDatasetalteracao.Required := False;
    Plano_ContasDatasetexclusao.SetParentComponent(Plano_ContasDataset);
    Plano_ContasDatasetexclusao.Name := 'Plano_ContasDatasetexclusao';
    Plano_ContasDatasetexclusao.FieldName := 'exclusao';
    Plano_ContasDatasetexclusao.Required := False;
    XDataClientPlano_ContasGet.SetParentComponent(Self);
    XDataClientPlano_ContasGet.Name := 'XDataClientPlano_ContasGet';
    XDataClientPlano_ContasGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientPlano_ContasGet, Self, 'OnLoad', 'XDataClientPlano_ContasGetLoad');
    XDataClientPlano_ContasGet.Left := 64;
    XDataClientPlano_ContasGet.Top := 8;
    XDataClientPlano_ContasDelete.SetParentComponent(Self);
    XDataClientPlano_ContasDelete.Name := 'XDataClientPlano_ContasDelete';
    XDataClientPlano_ContasDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientPlano_ContasDelete, Self, 'OnLoad', 'XDataClientPlano_ContasDeleteLoad');
    SetEvent(XDataClientPlano_ContasDelete, Self, 'OnError', 'XDataClientPlano_ContasDeleteError');
    XDataClientPlano_ContasDelete.Left := 64;
    XDataClientPlano_ContasDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbplano_contas1_id.AfterLoadDFMValues;
    edplano_contas1_id.AfterLoadDFMValues;
    lbplano_contas2_id.AfterLoadDFMValues;
    edplano_contas2_id.AfterLoadDFMValues;
    lbplano_contas3_id.AfterLoadDFMValues;
    edplano_contas3_id.AfterLoadDFMValues;
    lbplano_contas_contabil_id.AfterLoadDFMValues;
    edplano_contas_contabil_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbclasse.AfterLoadDFMValues;
    edclasse.AfterLoadDFMValues;
    lbpeso_ideal.AfterLoadDFMValues;
    edpeso_ideal.AfterLoadDFMValues;
    lbaparece_dre.AfterLoadDFMValues;
    edaparece_dre.AfterLoadDFMValues;
    lbdebito_credito.AfterLoadDFMValues;
    eddebito_credito.AfterLoadDFMValues;
    lbdeducao_adicao.AfterLoadDFMValues;
    eddeducao_adicao.AfterLoadDFMValues;
    lbdespesas.AfterLoadDFMValues;
    eddespesas.AfterLoadDFMValues;
    lbinvestimentos.AfterLoadDFMValues;
    edinvestimentos.AfterLoadDFMValues;
    lbbalanco_patrimonial.AfterLoadDFMValues;
    edbalanco_patrimonial.AfterLoadDFMValues;
    lbdemonstrativo_financeiro.AfterLoadDFMValues;
    eddemonstrativo_financeiro.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Plano_ContasDataset.AfterLoadDFMValues;
    Plano_ContasDatasetid.AfterLoadDFMValues;
    Plano_ContasDatasetaliado_id.AfterLoadDFMValues;
    Plano_ContasDatasetdata_base_id.AfterLoadDFMValues;
    Plano_ContasDatasetplano_contas1_id.AfterLoadDFMValues;
    Plano_ContasDatasetplano_contas2_id.AfterLoadDFMValues;
    Plano_ContasDatasetplano_contas3_id.AfterLoadDFMValues;
    Plano_ContasDatasetplano_contas_contabil_id.AfterLoadDFMValues;
    Plano_ContasDatasetnome.AfterLoadDFMValues;
    Plano_ContasDatasetclasse.AfterLoadDFMValues;
    Plano_ContasDatasetpeso_ideal.AfterLoadDFMValues;
    Plano_ContasDatasetaparece_dre.AfterLoadDFMValues;
    Plano_ContasDatasetdebito_credito.AfterLoadDFMValues;
    Plano_ContasDatasetdeducao_adicao.AfterLoadDFMValues;
    Plano_ContasDatasetdespesas.AfterLoadDFMValues;
    Plano_ContasDatasetinvestimentos.AfterLoadDFMValues;
    Plano_ContasDatasetbalanco_patrimonial.AfterLoadDFMValues;
    Plano_ContasDatasetdemonstrativo_financeiro.AfterLoadDFMValues;
    Plano_ContasDatasetcodigo_interno.AfterLoadDFMValues;
    Plano_ContasDatasetexcluido.AfterLoadDFMValues;
    Plano_ContasDatasetinclusao.AfterLoadDFMValues;
    Plano_ContasDatasetalteracao.AfterLoadDFMValues;
    Plano_ContasDatasetexclusao.AfterLoadDFMValues;
    XDataClientPlano_ContasGet.AfterLoadDFMValues;
    XDataClientPlano_ContasDelete.AfterLoadDFMValues;
  end;
end;

end.
